import { orderBy } from 'lodash-es';
import { ICriteria } from '~/connect/types';

export function sorterByName(values: ICriteria['values']) {
  const labelSorter = (value: ICriteria['values'][number]) =>
    value.label.toLowerCase();

  return orderBy(values, labelSorter);
}
